import * as microsoftTeams from '@microsoft/teams-js';

let teamsInitialized = false;
let isInTeams = false;

/**
 * Initialize Teams SDK and detect if running in Teams
 */
export async function initializeTeams() {
  if (teamsInitialized) {
    return isInTeams;
  }

  try {
    await microsoftTeams.app.initialize();
    const context = await microsoftTeams.app.getContext();
    isInTeams = true;
    teamsInitialized = true;
    console.log('Running inside Teams:', context.app.host.name);
    microsoftTeams.app.notifySuccess();
    return true;
  } catch (error) {
    // Not running in Teams
    isInTeams = false;
    teamsInitialized = true;
    console.log('Not running in Teams (standalone mode)');
    return false;
  }
}

/**
 * Check if app is running inside Teams
 */
export function isRunningInTeams() {
  return isInTeams;
}

/**
 * Get Teams SSO token
 * This uses the user's existing Teams session for silent authentication
 */
export async function getTeamsSsoToken() {
  if (!isInTeams) {
    throw new Error('Not running in Teams');
  }

  try {
    const token = await microsoftTeams.authentication.getAuthToken();
    return token;
  } catch (error) {
    console.error('Teams SSO token error:', error);
    throw error;
  }
}

/**
 * Authenticate using Teams popup (fallback if SSO fails)
 */
export async function authenticateWithTeamsPopup(loginUrl) {
  if (!isInTeams) {
    throw new Error('Not running in Teams');
  }

  return new Promise((resolve, reject) => {
    microsoftTeams.authentication.authenticate({
      url: loginUrl,
      width: 600,
      height: 535,
      successCallback: (result) => {
        resolve(result);
      },
      failureCallback: (reason) => {
        reject(new Error(reason));
      }
    });
  });
}
